const Loading = () =>{
    return (
        <div className="loading__icon">
            
        </div>
    )
}

export default Loading